<template>
    <span class="tag is-success">
        {{ translate("record_profile.result.win") }}
    </span>
</template>

<script setup lang="ts">
    import { translate } from "../translations";
</script>

<style scoped></style>
